<template>
    <tiptap-options-menu icon="dynamicValue" :title="$t('dynamic_value')" save-on-blur>
        <p>
            {{ $t('selecting_a_dynamic_value_will_replace_the_content_with_the_result_of_the_calculation') }}.
            {{ $t('dynamic_values_are_calculated_when_the_editor_content_is_displayed') }}.
        </p>
        <field-dynamic-value v-model="type" required />
    </tiptap-options-menu>
</template>

<script>
export default {
    name: 'TiptapDynamicValueOptions',
    components: {
        TiptapOptionsMenu: () =>
            import(
                /* webpackChunkName: "core" */
                '@/lib/tiptap/components/TiptapOptionsMenu.vue'
            ),
        FieldDynamicValue: () =>
            import(
                /* webpackChunkName: "fields" */
                '@/components/fields/DynamicValue'
            )
    },
    props: {
        options: {
            type: Object,
            required: true
        },
        updateAttributes: {
            type: Function,
            required: true
        }
    },
    computed: {
        type: {
            get() {
                return this.options.type;
            },
            set(type) {
                this.updateAttributes({ type });
            }
        }
    }
};
</script>
